// src/features/dashboard/components/StatusBadge.tsx
import { Check, Clock, CheckCheck, X } from 'lucide-react';
import type { OrderStatus } from '../types/dashboard.types';

interface StatusBadgeProps {
  status: OrderStatus;
}

const STATUS_CONFIG: Record<
  OrderStatus,
  { label: string; icon: typeof Check; className: string }
> = {
  pending: {
    label: 'در انتظار',
    icon: Clock,
    className: 'vania-badge vania-badge--amber',
  },
  paid: {
    label: 'پرداخت شده',
    icon: Check,
    className: 'vania-badge vania-badge--sky',
  },
  completed: {
    label: 'تکمیل شده',
    icon: CheckCheck,
    className: 'vania-badge vania-badge--teal',
  },
  cancelled: {
    label: 'لغو شده',
    icon: X,
    className: 'vania-badge vania-badge--rose',
  },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;

  return (
    <span className={config.className}>
      <Icon size={12} strokeWidth={2.5} />
      {config.label}
    </span>
  );
}
